import './src/scss/styles.scss';

import { wrapPageElement as wPE } from './gatsby-shared';

export const wrapPageElement = wPE;
